import { gql } from '@apollo/client';
export const TABLE_EVENTS_QUERY = gql`
  query JournalTableEvents($venueId: String!, $sentAfter: DateTime!) {
    tableEvents(venueId: $venueId, sentAfter: $sentAfter) {
      lastKey
      items
    }
  }
`;

export const REPORT_EVENTS_QUERY = gql`
  query JournalReportEvents($venueId: String!, $sentAfter: DateTime!) {
    reportEvents(venueId: $venueId, sentAfter: $sentAfter) {
      lastKey
      items
    }
  }
`;

export const COMPANY_QUERY = gql`
  query JournalCompany($companyId: ID!) {
    company: Company(id: $companyId) {
      id
      staffs {
        id
        name
      }
      items(filter: { deleted: false }) {
        id
        title
      }
      venues {
        id
        name

        tables {
          id
          code
        }
      }
    }
  }
`;

export enum TAB_TYPE {
  TABLE = 'TABLE',
  REPORT = 'REPORT',
}

export const TABLE_EVENTS_HEADERS = ['Action', 'Cheque', 'Info', 'User', 'Time'];
export const REPORT_EVENTS_HEADERS = ['Action', 'Id', 'Client', 'Device', 'Time'];

export const TABLE_SEARCH_KEYS = [
  'id',
  'amount',
  'chequeId',
  'staffId',
  'type',
  'staffName',
  'tableName',
  'itemName',
  'eventName',
];

export const REPORT_SEARCH_KEYS = [
  'id',
  'client',
  'action',
  'clientId',
  'companyId',
  'deviceId',
  'eventId',
  'type',
  'venueId',
];
